import React, { Component } from 'react';
import UserImage from 'Icons/nithin.png';
import Launcher  from 'Components/ChatWidget/Launcher';
import styles from '../../styles/components/_Chat.scss';
import { connect } from 'react-redux';
import { SEEKER } from '../../constants/commonConstants';
import { getUser } from 'Utils/storage';
import { 
    CLEAR_CHAT_MESSAGE_COUNT, 
    CLEAR_CHAT_MESSAGES,
    GET_CHAT_MESSAGES,
    SEND_CHAT_MESSAGE
} from 'Constants/actionConstants';
import { getItemFromLocal } from 'Utils/localStorage';

class Chat extends Component {

    state = {
        isOpen: false,
        selectedUser: {
            name: 'EveryOne',
            id: 1
        }
    }

    setIsOpen = (value) => {
        this.setState({isOpen: value}, () => {
            const { messages } = this.props;
            this.getMessages(messages.length ? messages[messages.length - 1].at : new Date().getTime(), true)
        });
    }

    getMessages = (timestamp, isNext=false, previousMessages) => {
        const { dispatch, rfq, userType } = this.props;
        const { isOpen } = this.state;
        const isSeeker = (userType == SEEKER);
        dispatch({
            type: GET_CHAT_MESSAGES,
            params: {
                rfqId : rfq.id,
                limit: 10,
                isNext: isNext,
                timestamp: timestamp || (new Date().getTime() + 2000000),
                is_open: isOpen,
                seekerCompanyId: !isSeeker ? getItemFromLocal("transporter_seeker_company_id") : undefined
            },
            onSuccess: this.startChatPoll.bind(this),
            previousMessages: previousMessages
        });
    }

    chatTimer = null;

    startChatPoll() {
        const { messages } = this.props;
        if(this.chatTimer) {
            clearTimeout(this.chatTimer)
        }
        this.chatTimer = setTimeout(() => {
            this.getMessages(messages.length ? messages[messages.length - 1].at : new Date().getTime(), messages.length?true:false);
        }, 5000)
    }

    _onMessageWasSent(message) {
        const { dispatch, rfq, userType, userId, messages } = this.props;
        const { selectedUser } = this.state;
        const isSeeker = userType == SEEKER;
        let params = {
            rfq_id : rfq.id,
            sender_id: getUser().id,
            user_name: getUser().adminName,
            is_seeker : userType == SEEKER,
            message : message.data.text
        }
        if(isSeeker) {
            if([1,2,3, '1', '2', '3'].includes(selectedUser.id)) {
                params.id = selectedUser.id;
            } else {
                params.chat_list = [{
                    "transporter_id": selectedUser.id,
                    "transporter_name": selectedUser.name
                }] 
            }
        } else {
            params.seekerCompanyId = getItemFromLocal("transporter_seeker_company_id");
        }
        dispatch({
            type: SEND_CHAT_MESSAGE,
            params,
            onSuccess: this.getMessages.bind(this, messages.length ? messages[messages.length - 1].at : new Date().getTime(), true),
            onError: this.getMessages.bind(this, messages.length ? messages[messages.length - 1].at : new Date().getTime(), true)
            
        });
    }

    loadPreviousMessages() {
        const { messages } = this.props;
        this.getMessages(messages[0].at, false, true);
    }

    componentDidMount() {
        this.getMessages();
    }
    
    componentWillUnmount() {
        if(this.chatTimer) {
            clearTimeout(this.chatTimer);
        }
        const { dispatch } = this.props;
        dispatch({
            type: CLEAR_CHAT_MESSAGES
        });
    }

    clearChatMessagesCount = () => {
        const { dispatch } = this.props;
        dispatch({
            type: CLEAR_CHAT_MESSAGE_COUNT
        })
    }

    onSelectUser = (e) => {
        const elObject = document.getElementById('chat-user-select');
        const name = elObject.selectedOptions[0].text;
        const value = elObject.value;
        this.setState({
            selectedUser: {
                name,
                id: [1,2,3, '1', '2', '3'].includes(value) ? +value : value
            }
        })
    }

    render() {
        const { rfq, messages, fetchingMessages, userId, newMessagesCount, chatMenu} = this.props;
        const user = getUser();
        return (
            <div className="chat-container">
                <Launcher
                agentProfile={{
                    teamName: rfq.rfqDetails.name,
                    caption: rfq.rfqNumber,
                    imageUrl: user.userImage || UserImage
                }}
                onMessageWasSent={this._onMessageWasSent.bind(this)}
                messageList={ messages }
                showEmoji
                newMessagesCount={newMessagesCount}
                userId={user.id}
                loadPreviousMessages={this.loadPreviousMessages.bind(this)}
                clearChatMessagesCount={this.clearChatMessagesCount}
                setIsOpen={this.setIsOpen}
                chatMenu={chatMenu}
                onSelectUser={this.onSelectUser}
                />
            </div>
        )
    }
}

const mapStateToProps = ({chat}) => {
    return {
        messages: chat.messages,
        newMessagesCount: chat.newMessagesCount,
        fetchingMessages: chat.fetchingMessages
    }
};


export default connect(mapStateToProps)(Chat);